import { useField } from 'formik'
import { Space } from 'antd'
import { useCallback, useMemo } from 'react'
import { InputNumber, InputNumberProps } from '../../InputNumber'
import type { FormikFieldProps } from '../typings/FieldProps'
import { numberValueToVpassKMValue } from './utils/numberValueToVpassKMValue'

// VPASS format is: '0 km', '99 km', '9999 km'

export type VPASSKilometersInputProps = FormikFieldProps & InputNumberProps

export const VPASSKilometersInput = ({
  min = 0,
  max = 9999,
  name,
  onChange: onChangeProp,
  onBlur: onBlurProp,
  value: _valueProp,
  ...restProps
}: VPASSKilometersInputProps) => {
  const [field, , helpers] = useField(name)
  const { value, onBlur } = field
  const { setValue } = helpers

  const handleBlur = useCallback(
    (event: any) => {
      onBlur(event)
      onBlurProp?.(event)
    },
    [onBlur, onBlurProp]
  )
  const handleChange = useCallback(
    (value: string | number | null) => {
      const stringValue = numberValueToVpassKMValue(value)
      setValue(stringValue)
    },
    [setValue]
  )

  const numberValue = useMemo(() => {
    return value ? Number(String(value).replace(' km', '').trim()) : undefined
  }, [value])

  return (
    <Space.Compact>
      <InputNumber
        key={name}
        name={name}
        value={numberValue}
        min={0}
        max={9999}
        step={1}
        onBlur={handleBlur}
        onChange={handleChange}
        controls={false}
        inputMode="numeric"
        type="number"
        precision={0}
        style={{ width: '100%' }}
        {...restProps}
      />
      <Space.Addon>km</Space.Addon>
    </Space.Compact>
  )
}
